import React, { Component } from "react";
import { connect } from "react-redux";
import "../../style";
import { isAuthorized, isCounterParty } from "../Common/CheckAuthorization";
import SubMenu from "../private/SubMenu";
import ReportsView from "./Reports/ReportsView";
import Forbidden from "../../template/private/Forbidden";
import Comingsoonpath from "../../assets/images/coming soon.jpg";
class Reports extends Component {
  constructor(props, context) {
    super(props, context);
  }

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {}

  render() {
    const menuName = "Reports";
    // if( isCounterParty() ){
    //   return <div className="coomingsoonimg"> 
    //   <img alt="Coming soon"  src={Comingsoonpath} />
    //   </div>
    // }
    return (
      isAuthorized() ? (
        <div className="">
          <SubMenu
            menuName={menuName}
            routes={this.props.route}
            handleChangeTabBody={this.updateTabBody}
          />
          <ReportsView />
        </div>
          ) :
            <Forbidden />
          );
  }
}
export default connect(
  null,
  {}
)(Reports);



// WEBPACK FOOTER //
// ./src/components/private/Reports.js